module.exports = __webpack_public_path__ + "img/sura-logo.22122ed0.jpg";